<div class="pex-toast-overlay">
    <div
        class="pex-toast-message animate__animated animate__fadeInUp animate__faster"
        [ngClass]="toast?.exitClass"
        *ngFor="let toast of toasts"
    >
        <div [innerHTML]="toast.message" id="toastText"></div>
    </div>
</div>
